module.exports = __webpack_public_path__ + "static/img/footerlogo2.bae5d17b.png";